module.exports = __webpack_public_path__ + "static/media/test1 (25).5fc3bbf0.jpg";